var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalendarGray(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.71094 0.78125H7.8125V0.3125C7.8125 0.139922 7.6726 0 7.5 0C7.3274 0 7.1875 0.139922 7.1875 0.3125V0.78125H2.8125V0.3125C2.8125 0.139922 2.6726 0 2.5 0C2.3274 0 2.1875 0.139922 2.1875 0.3125V0.78125H1.28906C0.578262 0.78125 0 1.35951 0 2.07031V8.71094C0 9.42174 0.578262 10 1.28906 10H8.71094C9.42174 10 10 9.42174 10 8.71094V2.07031C10 1.35951 9.42174 0.78125 8.71094 0.78125ZM1.28906 1.40625H2.1875V1.71875C2.1875 1.89133 2.3274 2.03125 2.5 2.03125C2.6726 2.03125 2.8125 1.89133 2.8125 1.71875V1.40625H7.1875V1.71875C7.1875 1.89133 7.3274 2.03125 7.5 2.03125C7.6726 2.03125 7.8125 1.89133 7.8125 1.71875V1.40625H8.71094C9.07711 1.40625 9.375 1.70414 9.375 2.07031V2.8125H0.625V2.07031C0.625 1.70414 0.922891 1.40625 1.28906 1.40625ZM8.71094 9.375H1.28906C0.922891 9.375 0.625 9.07711 0.625 8.71094V3.4375H9.375V8.71094C9.375 9.07711 9.07711 9.375 8.71094 9.375Z",
    fill: "#9E9E9E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarGray);
export default __webpack_public_path__ + "static/media/calendarGray.69da61bba13fd891c0f641017b573ff7.svg";
export { ForwardRef as ReactComponent };